/**
 * Created by andermurias on 25/6/17.
 */
import React, { Component } from 'react';
import Logo from '../elements/Logo';

import '../../styles/components/loader.css';

class Loader extends Component {
    render() {
        return (
            <div className={"loader"+(this.props.visible?" loader--show":"")}>
                <Logo className="loader__logo"/>
            </div>
        )
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/js/components/Loader.js